  <div class="card shadow-sm border-1 w-100 position-relative overflow-visible add-task-card" >
  <form @submit.prevent="add_task">
    <div class="p-2">
    <div class="d-flex align-items-center">
        <!-- <p>{{members}}</p> -->
         <div class="w-100">
        <textarea
            ref="taskNameInput"
            v-model="task_name"
            class="form-control form-control-sm text-xxs border-0 border-bottom add-task-name-input"
            placeholder="Enter a task name"
            @input="resizeTaskNameInput"
            rows="2"
        ></textarea>
        <p v-if="errors.task_name" class="text-danger  fs-xsm">{{ errors.task_name }}</p>
        </div>
        </div>

        <div
            class="d-flex align-items-center mb-2 fs-xsm position-relative add-task-date-trigger"
            role="button"
            tabindex="0"
            @click="triggerDatePicker"
            @keydown.enter.prevent="triggerDatePicker"
            @keydown.space.prevent="triggerDatePicker"
        >
        <i class="bi bi-calendar3 me-2"></i>
        <span class="small fw-500">
            {{ selectedDate ? formatDate(selectedDate) : "Set due date" }}
        </span>
        <input
          ref="dateInput"
          type="date"
          class="position-absolute add-task-date-input"
          v-model="selectedDate"
          aria-label="Set due date"
          @change="handleDateChange"
          @click.stop
        />
        </div>

        <!-- Trigger -->
<!-- Trigger -->
<div class="dropdown w-100 position-relative add-task-assign-dropdown">
<button
  type="button"
  class="border-0 mb-2 task-chip d-inline-flex align-items-center mw-100 text-start add-task-assign-trigger"
  data-bs-toggle="dropdown"
  data-bs-auto-close="outside"
  aria-expanded="false"
  @click="fetchPortalMembers"
>
   <template v-if="assignedMembers.length === 0">
    <i class="bi bi-person-plus me-2 fw-500"></i>
    <span class="small fw-500">Assign</span>
  </template>

  <div class="d-flex gap-1" v-else>
    <i class="bi bi-person-plus fs-6"></i>
    <div
      v-for="user in assignedMembers"
      :key="user.id"
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary align-items-center text-white py-2 w-20 h-20"
    >
      {{ getInitials(user.full_name) }}
    </div>
  </div>
</button>

<!-- Dropdown -->
<div class="dropdown-menu px-1 shadow border-0 assignment-dropdown add-task-assign-menu">
  <input
    type="text"
    class="form-control form-control-sm text-xxs rounded-3 border-0 border-bottom mb-2"
    placeholder="Type a name or email address"
    v-model="searchQuery"
  />

  <!-- Currently assigned users -->
  <div v-if="assignedMembers.length > 0" class="fw-bold text-muted small px-1 mb-2 fs-xsm">
    <div
      v-for="user in assignedMembers"
      :key="user.id"
      class="d-flex align-items-center px-2 py-1 mb-1 border-bottom rounded"
    >
    <div
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary align-items-center text-white py-2 w-20 h-20 me-2"
    >
      {{ getInitials(user.full_name) }}
    </div>
    <span class="text-dark small fs-xsm flex-grow-1">{{ user.full_name }}</span>
      <i class="bi bi-x me-2" @click.stop.prevent="removeAssignedUser(user)"></i>
  </div>
</div>
  <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Suggestions</div>

  <div
    v-for="member in filteredMembers"
    :key="member.id"
    class="d-flex align-items-center px-2 py-1 dropdown-item"
    @click.stop.prevent="assignUser(member)"
  >
    <div
      class="rounded-circle d-flex justify-content-center align-items-center me-2 py-2 text-xxs text-white bg-primary w-20 h-20"
    >
      {{ getInitials(member.full_name) }}
    </div>
    <span class="text-dark small fs-xsm">{{member.full_name}}</span>
  </div>
</div>
</div>

   <div class="card-footer bg-primary">
        <button class="btn  w-100 btn-sm text-xxs text-white" type="submit">Add task</button>
    </div>


    </div>

    </form>

  </div>
